module.exports = __webpack_public_path__ + "static/media/m13.be4e87b1.png";